import React, { useState } from "react";
import axios from 'axios';
import Cookies from 'js-cookie';
import ToastStore from '../../stores/ToastStore';
import { Card, Button, ProgressBar, Intent, Tooltip, Divider, Collapse, Icon } from "@blueprintjs/core";
import Flexbox from "flexbox-react";
import BlankPage from "../../components/goals/BlankPage";
import GoalProgressRow from "./GoalProgressRow";
import Avatar from "react-avatar";
import TextButton from "../../components/buttons-20250224T111359Z-001/buttons/TextButton.jsx";
import styles from "./CascadingGoalsList.module.css";
import goalIcon from "../../assets/GoalIcon.svg";
import Comment1 from "../../assets/Comment1.svg";
import Comment2 from "../../assets/Comment2.svg";
import Progress from "../../assets/Progress.svg";
import Weightage from "../../assets/Weightage.svg";
import EditIcon from "../../assets/editIcon.svg";
import Delete from "../../assets/Delete.svg";
import DescriptionIcon from "../../assets/Description.svg";
import TimeLeft from "../../assets/TimeLeft.svg";

const CascadingGoalsList = ({
  cascadingGoalList,
  selectedTimeframe,
  getStatusColor,
  getDaysLeft,
  handleEditCascadingGoal,
  handleDeleteCascadingGoal,
  handleEditGoal,
  handleDeleteGoal,
  getActiveAccountId,
  currentPageEmployeeId,
  onGoalLinked,
  isManagerFlow = false,
  initiatedBy  // true if the cascading goals are initiated by the Team goal component, false if the cascading goals are initiated by the goal component
}) => {

  const [openCascadeGoals, setOpenCascadeGoals] = useState({});
  const [linkingByCascadeId, setLinkingByCascadeId] = useState({});

  const showCascadingGoalActionBtn = initiatedBy === 'goal' && selectedTimeframe.is_editable;
  const showLinkedGoalActionBtn = initiatedBy === 'goal' && selectedTimeframe.is_editable;

  if (!cascadingGoalList || cascadingGoalList.length === 0) {
    return (
      <div className="push-30-t">
        <BlankPage
          title="No Cascading Goals Yet"
          description="You don't have any cascading goals."
        />
      </div>
    );
  }

  return (
    <>
      {cascadingGoalList?.length > 0 && cascadingGoalList.map(cascade => (
        <Card
          key={cascade.id}
          className="goal-card cascade-goal-card"
          style={{
            marginBottom: 16,
            borderRadius: 8,
            border: "1px solid #E4E7EC",
            padding: 15,
            boxShadow: "none"
          }}
        >
          <Flexbox flexDirection="row">
            <Flexbox>
              <div className="goal-icon-box">
                <img src={goalIcon} alt="cascade" />
              </div>
            </Flexbox>

            <Flexbox
              flexDirection="column"
              style={{ flex: 1, paddingLeft: 12 }}
            >
              <Flexbox
                alignItems="center"
                gap="8px"
                style={{
                  marginBottom: 8
                }}
              >
                <span
                  className="goal-title"
                  style={{ cursor: "pointer" }}
                >
                  {cascade.title}
                </span>


                <Tooltip portalContainer={document.body}
                  content={cascade.description}
                  placement="top"
                  popoverClassName="goal-description-tooltip"
                >
                  <div
                    style={{
                      cursor: "pointer",
                      marginTop: 5
                    }}
                  >
                    <img
                      src={goalIcon}
                      alt=""
                      style={{
                        width: 20,
                        height: 20
                      }}
                    />
                  </div>
                </Tooltip>
              </Flexbox>
              <Flexbox flexDirection="row" gap="16px" alignItems="center" className="push-10-b">
                <Avatar src={cascade?.cascading_owner_image} size={20} round={true} />
                <span className="goal-owner-name push-5-l">{cascade?.cascading_owner}</span>
              </Flexbox>

              <Flexbox
                flexDirection="row"
                gap="16px"
                alignItems="center"
              >
                <Flexbox
                  alignItems="center"
                  gap="8px"
                >
                  <Tooltip content="Weightage" portalContainer={document.body}>
                    <img
                      src={Weightage}
                      alt=""
                      style={{
                        width: 20,
                        height: 20
                      }}
                    />
                  </Tooltip>

                  <span className="weight-value">
                    {cascade.weightage || "-"}
                  </span>
                </Flexbox>

                <Divider />

                <Tooltip content="Progress" portalContainer={document.body}>
                  <img
                    src={Progress}
                    alt=""
                    style={{
                      width: 20,
                      height: 20
                    }}
                  />
                </Tooltip>

                <div style={{ width: "25%", marginLeft: "10px", marginRight: "10px" }}>
                  <ProgressBar
                    value={cascade.progress_percentage / 100 || 0}
                    intent={Intent.NONE}
                    className="goal-progress-bar bp3-no-stripes"
                    style={{ maxWidth: "50%" }}
                  />

                </div>


                <span>
                  {cascade.progress_percentage || 0}%
                </span>
              </Flexbox>
            </Flexbox>

            {showCascadingGoalActionBtn && currentPageEmployeeId === cascade.created_by && (
              <Flexbox
                alignItems="flex-start"
                className="goal-item-actions cascade-header-actions"
              >
                <Tooltip content="Edit cascading goal" placement="top" portalContainer={document.body}>
                  <Button
                    icon={<img src={EditIcon} style={{ width: 18, height: 18 }} />}
                    minimal
                    onClick={() => handleEditCascadingGoal(cascade)}
                    className="no-hover-btn"
                  // style={{ paddingRight: "0px" }}
                  />
                </Tooltip>
                <Tooltip content="Delete cascading goal" placement="top" portalContainer={document.body}>
                  <Button
                    icon={
                      <img src={Delete} style={{ width: 18, height: 18 }} />
                    }
                    minimal
                    className="no-hover-btn"
                    onClick={() => handleDeleteCascadingGoal(cascade)}
                  />
                </Tooltip>
              </Flexbox>
            )}
          </Flexbox>

          <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "16px", fontWeight: "600", color: "#2e2e2e", marginBottom: "10px", marginTop: "20px" }}>

            <div
              className="linked-goals-badge"
              onClick={() => {
                if ((cascade?.goals_for_cascading?.length || 0) > 0) {
                  setOpenCascadeGoals(prev => ({
                    ...prev,
                    [cascade.id]: !prev[cascade.id]
                  }));
                }
              }}
            >
              <Icon
                icon={
                  openCascadeGoals[cascade.id]
                    ? "chevron-down"
                    : "chevron-right"
                }
                size={12}
              />
              <span>
                {cascade?.goals_for_cascading?.length || 0} Linked Goals
              </span>
            </div>

            <Tooltip
              portalContainer={document.body}
              content={
                <div style={{ maxWidth: "340px", lineHeight: "1.5" }}>
                  <div style={{ marginTop: "4px" }}>
                    Goals connected to this goal to support alignment and track related objectives.
                  </div>

                  <div style={{ marginTop: "6px" }}>
                    To link a goal, create a new goal or edit an existing goal, select
                    the cascading goal as its parent, and save the goal.
                  </div>
                </div>
              }
              placement="top"
              hoverOpenDelay={100}
              boundary="viewport"
              className={`custom-bp-tooltip ${styles.linkedGoalsTooltip}`}
              targetClassName={styles.linkedGoalsTooltip}
            >
              <Icon icon="help" size={14} color="#64748B" />

            </Tooltip>
            {showCascadingGoalActionBtn &&
              <TextButton
                type="button"
                btnClass={styles.createLinkedGoal}
                title="Create a new goal linked to this cascading goal"
                aria-busy={!!linkingByCascadeId[cascade.id]}
                text={
                  <>
                    <Icon icon="plus" size={14} aria-hidden="true" />
                    <span style={{ fontSize: "14px" }}>{linkingByCascadeId[cascade.id] ? "Creating..." : "Add New Goal"}</span>
                  </>
                }
                disabled={!!linkingByCascadeId[cascade.id]}
                onClick={async () => {
                  if (linkingByCascadeId[cascade.id]) return;

                  const goalSettingId = selectedTimeframe?.id;
                  if (!goalSettingId) {
                    ToastStore.showToast('Please select a goal cycle first', 'warning');
                    return;
                  }

                  const actionByManager = isManagerFlow || initiatedBy === 'team';
                  if (actionByManager && !currentPageEmployeeId) {
                    ToastStore.showToast('Please select an employee first', 'warning');
                    return;
                  }

                  setLinkingByCascadeId(prev => ({ ...prev, [cascade.id]: true }));
                  try {
                    const payload = {
                      goal_setting_id: goalSettingId,
                      goal_cascade_id: cascade.id,
                      ...(actionByManager && {
                        action_by_manager: true,
                        employee_id: currentPageEmployeeId
                      })
                    };

                    await axios.post(`${Cookies.get('apiEnv')}/goal_cascades/add_goal_by_cascading`, payload);
                    ToastStore.showToast('Goal created from cascade', 'success');
                    await onGoalLinked();
                    setOpenCascadeGoals(prev => ({ ...prev, [cascade.id]: true }));
                  } catch (err) {
                    const message = err?.response?.data?.message || err?.response?.data?.error || 'Failed to link goal';
                    ToastStore.showToast(message, 'danger');
                  } finally {
                    setLinkingByCascadeId(prev => ({ ...prev, [cascade.id]: false }));
                  }
                }}
              />}
          </div>

          <Collapse isOpen={openCascadeGoals[cascade.id]}>
            <div
              style={{
                marginTop: 16,
                paddingLeft: 45
              }}
            >
              {cascade.goals_for_cascading?.length > 0 && cascade.goals_for_cascading.map(goal => (
                <Card
                  key={goal.id}
                  className="goal-card cascade-linked-goal-card"
                >
                  <Flexbox
                    flexDirection="row"
                  >
                    <Flexbox flexDirection="column">
                      <div className="goal-icon-box" role="img" aria-label="goal-icon">
                        <img src={goalIcon} alt={"goalIcon"}></img>
                      </div>
                    </Flexbox>

                    {/* Left Section: Title + Description */}
                    <Flexbox flexDirection="column" style={{ flex: 1, paddingLeft: "12px" }}>

                      <Flexbox alignItems="center" gap="8px" style={{ marginBottom: 8 }}>
                        <span onClick={() => handleEditGoal(goal)} className="goal-title">
                          {goal.title}
                        </span>
                        {goal.user_comment && (
                          <Tooltip portalContainer={document.body} content={goal.user_comment} placement="top" popoverClassName="goal-description-tooltip">
                            <div style={{ cursor: "pointer", marginTop: '5px' }}>
                              <img
                                src={Comment1}
                                alt="comment icon"
                                style={{ width: 20, height: 20, marginRight: '5px' }}
                              />
                            </div>
                          </Tooltip>
                        )}
                        {goal.goal_comment && (
                          <Tooltip portalContainer={document.body} content={goal.goal_comment} placement="top" popoverClassName="goal-description-tooltip">
                            <div style={{ cursor: "pointer", marginTop: '5px' }}>
                              <img
                                src={Comment2}
                                alt="comment icon"
                                style={{ width: 20, height: 20, marginRight: '5px' }}
                              />
                            </div>
                          </Tooltip>
                        )}
                        {/* {goal.description && ( */}
                        <Tooltip portalContainer={document.body} content={goal.description} placement="top" popoverClassName="goal-description-tooltip">
                          <div style={{ cursor: "pointer", marginTop: '5px' }}>
                            <img
                              src={DescriptionIcon}
                              alt="description icon"
                              style={{ width: 20, height: 20, marginRight: '5px' }}
                            />
                          </div>
                        </Tooltip>
                        {/* )} */}
                      </Flexbox>
                      {/* Description under title removed as per request */}

                      <Flexbox flexDirection="row" gap="16px" alignItems="center" style={{ marginBottom: "10px" }}>
                        <Avatar src={goal.goal_owner_image} size={20} round={true} />
                        <span className="goal-owner-name push-5-l">{goal.goal_owner_name}</span>
                      </Flexbox>

                      <Flexbox flexDirection="row" gap="16px" className="weitage-progres-row" alignItems="center">
                        <Flexbox flexDirection="row" display="flex" alignItems="center" gap="8px">
                          <Tooltip portalContainer={document.body} content={"Weightage"} placement="top">
                            <img
                              src={Weightage}
                              alt="weightage icon"
                              style={{ width: 20, height: 20, marginRight: '5px', marginTop: '4px' }}
                            />
                          </Tooltip>
                          <span className="weight-value  weight-value-fixed ">{goal.goal_weight}</span>
                        </Flexbox>
                        <Divider className="push-10-l push-10-r"></Divider>
                        <Flexbox flexDirection="row" display="flex" alignItems="center" gap="8px">
                          <Tooltip portalContainer={document.body} content={"Days left"} placement="top">
                            <img
                              src={TimeLeft}
                              alt="time left icon"
                              style={{ width: 20, height: 20, marginRight: '5px', marginTop: '5px' }}
                            />
                          </Tooltip>
                          {/* <span className="weight-title days-left-fixed "> {getDaysLeft(goal)}</span> */}
                        </Flexbox>
                        <Divider className="push-10-l push-10-r"></Divider>
                        {goal?.file_url &&
                          <>
                            <Flexbox flexDirection="row" display="flex" alignItems="center" gap="8px">
                              <Tooltip portalContainer={document.body} content={goal.file_name || "Attached File"} placement="top">
                                <div>
                                  <a href={goal.file_url} target="_blank" rel="noopener noreferrer" style={{ color: "#106ba3", textDecoration: "underline", cursor: "pointer" }}>
                                    <Icon icon="paperclip" size={12} />
                                  </a>
                                </div>
                              </Tooltip>
                            </Flexbox>
                            <Divider className="push-10-l push-10-r"></Divider>
                          </>
                        }

                        <Tooltip portalContainer={document.body} content={"Progress"} placement="top">
                          <img
                            src={Progress}
                            alt="progress icon"
                            style={{ width: 20, height: 20, marginRight: '5px', marginTop: '4px' }}
                          />
                        </Tooltip>
                        <GoalProgressRow goal={goal} accountId={getActiveAccountId()} />
                      </Flexbox>

                    </Flexbox>

                    {/* Right Section: Status + Actions */}
                    <Flexbox flexDirection="row" alignItems="flex-start" className="goal-header-actions">
                      <div
                        //className="push-10-l push-10-r"
                        style={{
                          border: `1px solid ${getStatusColor(goal.goal_progress_states)} `,
                          borderRadius: "20px",
                          padding: "6px 18px"
                        }}
                      >
                        <span style={{ fontWeight: "400", color: getStatusColor(goal.goal_progress_states) }}>{goal.goal_progress_states}</span>
                      </div>
                      {goal.is_goal_owner && showLinkedGoalActionBtn && (
                        <Flexbox className="goal-item-actions" alignItems="center">
                          <Tooltip content="Edit goal" placement="top" portalContainer={document.body}>
                            <Button
                              icon={<img src={EditIcon} style={{ width: 18, height: 18 }} />}
                              minimal
                              onClick={() => handleEditGoal(goal)}
                              className="no-hover-btn"
                            />
                          </Tooltip>
                          <Tooltip content="Delete goal" placement="top" portalContainer={document.body}>
                            <Button
                              icon={<img src={Delete} style={{ width: 18, height: 18 }} />}
                              minimal
                              className="no-hover-btn"
                              onClick={() => handleDeleteGoal(goal)}
                            />
                          </Tooltip>
                        </Flexbox>
                      )}
                      {initiatedBy === 'team' && (currentPageEmployeeId === goal?.goal_owner_id) && (
                        <Flexbox className="goal-item-actions" alignItems="center">
                          <Tooltip content="Edit goal" placement="top" portalContainer={document.body}>
                            <Button
                              icon={<img src={EditIcon} style={{ width: 18, height: 18 }} />}
                              minimal
                              onClick={() => handleEditGoal(goal)}
                              className="no-hover-btn"
                            />
                          </Tooltip>
                        </Flexbox>)}

                    </Flexbox>
                  </Flexbox>

                  <Flexbox justifyContent="space-between">
                    <Flexbox flexDirection="column" style={{ flex: 1 }}>
                    </Flexbox>

                  </Flexbox>
                </Card>
              ))}
            </div>
          </Collapse>
        </Card>
      ))}
    </>
  );
};

export default CascadingGoalsList;
